import nineteenninetysevena from "./1997afull.jpg";
import nineteenninetysevenb from "./1997bfull.jpg";
import lonelymouthfull from "./lonelymouthfull.jpg";
import properties1 from "./properties1full.jpg";
import properties2 from "./properties2full.jpg";
import properties3 from "./properties3full.jpg";
import softnessfades from "./softenessfades.jpg";
import pulsefull from "./pulsefull.jpg";
import feeld from "./feeld.jpg";
import commission2 from "./commission2.png";
import bath from "./bath.jpeg";
import compromise from "./compromise.jpeg";
import deterioration from "./deterioration.jpeg";
import dreamlingers from "./dream-lingers.jpeg";
import georgianbay from "./georgianbay.jpeg";
import swf from "./swf.jpeg";
import threecolorsblue from "./threecolorsblue.jpg";
import vanity from "./vanity.jpeg";
import velvetonthechair from "./velvetonthechair.jpg";
import wait from "./wait.jpg";

const Collections = {
  fossilEphemeral: [
    {
      painting: nineteenninetysevena,
      className: "painting",
      caption: `<i>1997: Currants</i>, acrylic on canvas, 9x12”, 2024`,
    },
    {
      painting: nineteenninetysevenb,
      className: "painting",
      caption: `<i>1997: Relative</i>, acrylic on canvas, 9x12”, 2024`,
    },
    {
      painting: lonelymouthfull,
      className: "painting",
      caption: `<i>Lonely Mouth</i>, acrylic on canvas, 7x9”, 2024`,
    },
    {
      painting: pulsefull,
      className: "painting",
      caption: `<i>Pulse</i>, acrylic on canvas, 7x9”, 2024`,
    },
    {
      painting: softnessfades,
      className: "painting",
      caption: `<i>Softness Fades Away</i>, acrylic on canvas, 16x20”, 2023`,
    },
    {
      painting: properties1,
      className: "painting series",
      caption: `<i>Healing Properties 1</i>, acrylic on canvas, 8x10”, 2023`,
    },
    {
      painting: properties2,
      className: "painting series",
      caption: `<i>Healing Properties 2</i>, acrylic on canvas, 8x10”, 2023`,
    },
    {
      painting: properties3,
      className: "painting",
      caption: `<i>Healing Properties 3</i>, acrylic on canvas, 8x10”, 2023`,
    },
    {
      painting: wait,
      className: "painting",
      caption: `<i>Wait</i>, acrylic on canvas, 22x28", 2023`,
    },
  ],
  commissions: [
    {
      painting: commission2,
      className: "painting",
      caption: `<i>Cancer Stellium</i>, acrylic on canvas, 22x28", 2023`,
    },
    {
      painting: feeld,
      className: "painting",
      caption: `<i>Feeld Commission</i>, oil on canvas, 8x12", 2024`,
    },
  ],
  miscellaneous: [
    {
      painting: velvetonthechair,
      className: "painting",
      caption: `<i>Velvet on the Chair</i>, acrylic on canvas, 8x10", 2024`,
    },
    {
      painting: vanity,
      className: "painting",
      caption: `<i>Vanity</i>, acrylic on canvas, 20x24”, 2023`,
    },
    {
      painting: bath,
      className: "painting",
      caption: `<i>Bath</i>, acrylic on canvas, 25x45”, 2023`,
    },
    {
      painting: georgianbay,
      className: "painting",
      caption: `<i>Georgian Bay</i>, acrylic on canvas, 16x20”, 2023`,
    },
    {
      painting: deterioration,
      className: "painting",
      caption: `<i>Deterioration</i>, acrylic on canvas, 11x14”, 2022`,
    },
    {
      painting: swf,
      className: "painting",
      caption: `<i>Single White Female</i>, acrylic on canvas, 20x22”, 2022`,
    },
    {
      painting: threecolorsblue,
      className: "painting",
      caption: `<i>Three Colors Blue</i>, acrylic on canvas, 30x36”, 2021`,
    },
    {
      painting: compromise,
      className: "painting",
      caption: `<i>Compromise</i>, acrylic on canvas, 20x28”, 2021`,
    },
    {
      painting: dreamlingers,
      className: "painting",
      caption: `<i>The Dream Lingers Like a Tomb</i>, acrylic on canvas, 36x40”, 2021`,
    },
  ],
  feExhibitionText: {
    pOne: `Rebecca Storm’s paintings are like intrusive thoughts. The word “limerence” comes to mind. Love as a psychic intruder, dedication not without dolor. Love like the buzzing red of the bedside alarm. Love like a perpetual emergency. Life clock-hurried but slowed by the steady, sticky pulses of the internal body. In Storm’s works, metered time is disturbed by the ecstatic corporeal. Enraptured, engorged, her paintings are preoccupied with how time is felt, like the careening breakneck of desire, or the slow-drip stagnation of fear.`,
    pTwo: `Out of the murk of experience materializes bright moments that hold, challenging the onward drone. Storm paints diaristic bursts, lush and saturated flickers of memory, that allude to the weight of emotion held in the mundane. A camera flash reds the eye. A ring-finger fiddle belies an anxious mind. A glass childhood charm found decades later in an eBay auction speaks to a fragile family history. The sweet terror of passing time. What choice do we have but to accept it?`,
    pThree: `Time is considered too in the practical application of paint. Working with multiple layers of barely visible, faintly tinted glazes, Storm’s process involves subtleties of pause, perception, and reflection. As drying time extends, the work is imbued with wait. Surfaces are dark, reflective and almost impenetrable to the eye. A white cosmo shimmers in the pearly light of recall, the eye squints to see into the past. Be still, life, the works plead in horror, while they also hold a blush-cheeked appreciation for what wildly grows. Storm’s paintings are like when the sun lights dust floating in a quiet room, when time briefly thickens and holds a texture. With Fossil Ephemeral, the artist examines what is felt in the fleeting, pulls focus, and shapes these small, intruding moments into the only true form that time allows.`,
    pFour: `Exhibition Text by Olivia Whittick`,
  },
};

export default Collections;
